import { render, staticRenderFns } from "./SchemaSelector.vue?vue&type=template&id=37290374&"
import script from "./SchemaSelector.vue?vue&type=script&lang=ts&"
export * from "./SchemaSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports